import api from "Common/Client/Interceptor";

export const fetchExpertDashboardData = async (token) => {
  try {
    const response = await api.get("/indv/Dashboard/ExpertDashboard", {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });    

    console.log("................ expert data:", response.data);
    return response.data;
  } catch (error) {
    console.error(" Error expert data:", error);
    throw error;
  }
};

export const fetchSkillsData = async () => {
  try {
    const response = await api.get("/indv/CourseCategory/expert/skill-sets");  

    console.log("................ skills  data:", response.data);
    return response.data;
  } catch (error) {
    console.error(" Error fetching skills:", error);
    throw error;
  }
};


